import type SubstrateSearchRequest from '../../data/schema/SubstrateSearchRequest';
import type { SearchResultMessage } from '../../data/schema/SubstrateSearchResponse';
import type Message from 'owa-service/lib/contract/Message';
import {
    convertToNormalizedSubject,
    convertToItemId,
    convertUtcDateTimeToRequestTimeZone,
    convertToFlagType,
    convertRecipientToSingleRecipientType,
    convertToFolderId,
    convertSearchSortOrder,
} from './converterHelpers';
import { isFeatureEnabled } from 'owa-feature-flags';
import { convertRestIdToEwsId } from 'owa-identifiers';

export default function convertSearchResultMessageToMessageType(
    searchMessage: SearchResultMessage,
    request: SubstrateSearchRequest
): Message {
    const normalizedSubject = convertToNormalizedSubject(searchMessage.Subject);
    const normalizedItemId = isFeatureEnabled('fwk-immutable-ids')
        ? searchMessage.ImmutableId
            ? { Id: convertRestIdToEwsId(searchMessage.ImmutableId), ChangeKey: null }
            : searchMessage.ItemId
        : searchMessage.ItemId;

    return {
        Categories: searchMessage.Categories,
        ConversationId: convertToItemId(searchMessage.ConversationId),
        ConversationIndex: searchMessage.ConversationIndex,
        ConversationThreadId: {
            Id: searchMessage.ConversationThreadId,
            ChangeKey: undefined,
        },
        ConversationTopic: normalizedSubject,
        DateTimeReceived: convertUtcDateTimeToRequestTimeZone(
            searchMessage.DateTimeReceived,
            request
        ),
        DateTimeSent:
            searchMessage.DateTimeSent &&
            convertUtcDateTimeToRequestTimeZone(searchMessage.DateTimeSent, request),
        LastModifiedTime: convertUtcDateTimeToRequestTimeZone(
            searchMessage.DateTimeLastModified,
            request
        ),
        DisplayBcc: searchMessage.DisplayBcc,
        DisplayCc: searchMessage.DisplayCc,
        DisplayTo: searchMessage.DisplayTo,
        Flag: convertToFlagType(searchMessage.Flag),
        From: convertRecipientToSingleRecipientType(searchMessage.From),
        HasAttachments: searchMessage.HasAttachments,
        Hashtags: searchMessage.Hashtags,
        IconIndex: searchMessage.IconIndex,
        Importance: searchMessage.Importance,
        IsDraft: searchMessage.IsDraft,
        IsRead: searchMessage.IsRead,
        ItemClass: searchMessage.ItemClass || 'IPM.Note',
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (65,9): Type 'SearchResultItemId | { Id: string | null; ChangeKey: null; }' is not assignable to type 'ItemId | undefined'.
        // @ts-expect-error
        ItemId: normalizedItemId,
        MailboxGuids: searchMessage.MailboxGuids,
        ParentFolderDisplayName: searchMessage.ParentFolderDisplayName,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (70,9): Type 'import("packages/framework/owa-graph-schema/lib/__generated__/schema.all.interface").FolderId' is not assignable to type 'import("C:/Users/loicbe/workspace/client-web/shared/internal/owa-service/lib/contract/FolderId").default'.
        // @ts-expect-error
        ParentFolderId: convertToFolderId(searchMessage.ParentFolderId),
        Preview: searchMessage.Preview,
        Sender: convertRecipientToSingleRecipientType(searchMessage.Sender),
        SenderSMTPAddress: searchMessage.SenderSMTPAddress,
        Sensitivity: searchMessage.Sensitivity,
        SerializedImmutableId: searchMessage.ImmutableId,
        SortOrderSource: convertSearchSortOrder(searchMessage.SortOrderSource),
        Subject: searchMessage.Subject,
        MentionedMe: searchMessage.MentionsPreview?.IsMentioned,
        ExtendedProperty: [
            {
                // WellKnownProperties.NormalizedSubjectProperty
                ExtendedFieldURI: {
                    DistinguishedPropertySetId: 'Common',
                    PropertyId: 3613,
                    PropertyType: 'String',
                },
                Value: normalizedSubject,
            },
        ],
    };
}
